"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(value,min,max){if(value>max){return max}if(value<min){return min}return value};


//////////////////
// WEBPACK FOOTER
// ../~/@andrew-codes/color-functions/dist/utilities/clamp.js
// module id = 104
// module chunks = 0